import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { take, concatMap, filter, map, toArray } from 'rxjs/operators';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { Estado } from 'src/app/models/entities/estado';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { ObraService } from 'src/app/services/obra.service';
import { from } from 'rxjs';
import { Obra } from 'src/app/models/entities/obra';
import { LevantamientoObra } from 'src/app/models/entities/levantamiento-obra';
import { LevantamientoObraService } from 'src/app/services/levantamiento-obra.service';
import { ObrasHistoricoService } from 'src/app/services/obras-historico.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { Usuario } from 'src/app/models/entities/usuario';
import { ObrasHistoricoDto } from 'src/app/models/dtos/obras-historico-dto';
import { ObraHistorico } from 'src/app/models/entities/obra-historico';
import { ObraHistoricoDto } from 'src/app/models/dtos/obra-historico-dto';
import { Table } from 'primeng/table';
import { MultiSelect } from 'primeng/multiselect';
import { Router } from '@angular/router';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'consultar-historico-obras',
  templateUrl: './consultar-historico-obras.component.html',
  styleUrls: ['./consultar-historico-obras.component.scss']
})
export class ConsultarHistoricoObrasComponent implements OnInit {

  @ViewChild('dt')
  private table: Table;

  @ViewChild('modalFichaTecnicaHistorico')
  private modalFichaTecnicaHistorico: any;

  @ViewChildren('or') nombreOrgienRecursos: QueryList<MultiSelect>;

  public catEstados: Estado[] = [];
  public catDireccionesAdjuntas: ElementoCatalogo[] = [];
  public catCarpetas: ElementoCatalogo[] = [];
  public catSecciones: ElementoCatalogo[] = [];
  public catTipoLevantamiento: ElementoCatalogo[] = [];
  public catTipoObra: ElementoCatalogo[] = [];
  public catTiposOrigenRecursos: ElementoCatalogo[] = [];

  public buscadorForm: FormGroup = null;

  public informacionObras: ObraHistoricoDto[] = [];
  public informacionObrasFiltradas: ObraHistoricoDto[] = [];
  public obraSeleccionada: ObraHistoricoDto;
  public obrasHistorico: ObrasHistoricoDto[] = [];
  public obrasHistoricoCompleto: ObrasHistoricoDto[] = [];

  public obraSeleccionadaBool: boolean = false;

  public cols: any[] = [
    { field: 'nombreUsuarioActualizacion', header: 'Usuario Actualización' },
    { field: 'fechaActualizacion', header: 'Fecha Actualización' },
    { field: 'obra.longitudTotal', header: 'Meta Total' },
    { field: 'obra.inversionTotal', header: 'Costo Total' },
    { field: 'nombreTipoRecurso', header: 'Origen Recursos' },
    { field: 'obra.avanceFisicoGlobal', header: 'Avance Físico Global' },
    { field: 'obra.avanceFinancieroGlobal', header: 'Avance Financiero Global' },
    { field: 'obra.registroSHCP', header: 'Registro SHCP' }
  ];

  constructor(private formBuilder: FormBuilder,
    private facadeSesionService: FacadeSesionService,
    private catalogoService: CatalogoService,
    private obraService: ObraService,
    private levantamientoObraService: LevantamientoObraService,
    private obraHistoricoService: ObrasHistoricoService,
    private usuarioService: UsuarioService,
    private router: Router,
    private loaderService: LoaderService) { }

  async ngOnInit() {
    this.loaderService.activarLoaderScreen();
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad('Búsqueda de histórico de obra');
    await this.obtenerCatalogos();
    await this.obtenerInformacionObras();
    this.inicializarForm();
  }

  public async obtenerCatalogos(): Promise<any> {
    this.catEstados = await this.catalogoService.obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS).pipe(take(1)).toPromise();
    this.catDireccionesAdjuntas = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.DIRECCIONES_ADJUNTAS).pipe(take(1)).toPromise();
    this.catCarpetas = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.CARPETAS).pipe(take(1)).toPromise();
    this.catSecciones = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.SECCIONES).pipe(take(1)).toPromise();
    this.catTipoLevantamiento = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_LEVANTAMIENTOS).pipe(take(1)).toPromise();
    this.catTipoObra = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS).pipe(take(1)).toPromise();
    this.catTiposOrigenRecursos = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.ORIGEN_RECURSOS).pipe(
      take(1),
      map((tiposObra: ElementoCatalogo[]) => {
        return tiposObra.map((tipoRecurso: ElementoCatalogo) => ({
          key: tipoRecurso.key,
          nombre: tipoRecurso.nombre,
          label: tipoRecurso.nombre,
          value: tipoRecurso.nombre
        }) as any);
      })
    ).toPromise();
  }

  public async obtenerInformacionObras(): Promise<any> {
    let catalogoTipoObra: ElementoCatalogo[] = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS).pipe(take(1)).toPromise();
    this.informacionObras = await this.obraService.findAll().pipe(
      concatMap(
        (obras: Obra[]) => from(obras).pipe(
          concatMap((obra: Obra) => this.levantamientoObraService.findByKey(obra.keyLevantamientoObra).pipe(
            take(1),
            concatMap((levantamientoObra: LevantamientoObra) => this.catalogoService.obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS).pipe(
              take(1),
              map((estados: Estado[]) => {
                let estado: Estado = estados.find((estado: Estado) => estado.key === levantamientoObra.keyCatEstado);
                return {
                  nombreEstado: estado.nombre,
                  nombreObra: levantamientoObra.nombreObra,
                  nombreTipoObra: catalogoTipoObra.find((c: ElementoCatalogo) => c.key === levantamientoObra.keyCatTipoObra).nombre,
                  nombreTramoLicitacion: levantamientoObra.nombreTramoLicitacion,
                  keyCatDireccionAdjunta: levantamientoObra.keyCatDireccionAdjunta,
                  obra
                } as unknown as ObraHistoricoDto;
              })
            ))
          )),
          toArray()
        )
      ),
      take(1)
    ).toPromise();
    this.loaderService.desactivarLoaderScreen();
  }

  public inicializarForm(): void {
    this.buscadorForm = this.formBuilder.group({
      keyEstado: new FormControl('-1'),
      keyObra: new FormControl('-1'),
    });
    this.buscadorForm.get('keyObra').disable();
    this.buscadorForm.get('keyEstado').valueChanges.subscribe(
      (keyEstado: string) => {
        if (keyEstado === '-1') {
          this.buscadorForm.get('keyObra').disable();
          this.buscadorForm.get('keyObra').setValue("'-1'");
        } else {
          this.buscadorForm.get('keyObra').enable();
          this.informacionObrasFiltradas = this.informacionObras.filter((obra: ObraHistoricoDto) => obra.obra.estado === keyEstado);
        }
      }
    );

    this.buscadorForm.get('keyObra').valueChanges.subscribe(
      async (keyObra: string) => {
        if (keyObra === '-1') {
          this.obraSeleccionada = null;
          this.informacionObrasFiltradas = [];
        } else {
          this.obraSeleccionada = this.informacionObrasFiltradas.find((obraSeleccionada: ObraHistoricoDto) => obraSeleccionada.obra.key === keyObra);
          this.obrasHistorico = await this.obraHistoricoService.findByKeyObra(keyObra).pipe(
            take(1),
            concatMap(
              (obras: ObraHistorico[]) => from(obras).pipe(
                concatMap((obra: ObraHistorico) => this.usuarioService.findByKey(obra.keyUsuarioActualizacion).pipe(
                  take(1),
                  map((usuarioActualizacion: Usuario) => {
                    // let nombreEstado: string = this.catTiposOrigenRecursos.find((estado: Estado) => estado.key === obra.estado).nombre;
                    let nombreOrigenRecurso: string = this.catTiposOrigenRecursos.find((origenRecurso: ElementoCatalogo) => origenRecurso.key === obra.keyCatOrigenRecursos).nombre;
                    let nombreTipoCarpeta: string = this.catCarpetas.find((carpeta: ElementoCatalogo) => carpeta.key === obra.keyCatCarpeta).nombre;
                    let nombreTipoSeccion: string = this.catSecciones.find((seccion: ElementoCatalogo) => seccion.key === obra.keyCatSeccion).nombre;
                    return {
                      // nombreEstado: nombreEstado,
                      nombreObra: this.obraSeleccionada.nombreObra,
                      nombreTipoRecurso: nombreOrigenRecurso,
                      nombreTipoCarpeta: nombreTipoCarpeta,
                      nombreTipoSeccion: nombreTipoSeccion,
                      fechaActualizacion: new Date(obra.fechaActualizacion),
                      nombreUsuarioActualizacion: usuarioActualizacion.nombre + " " + usuarioActualizacion.primerApellido + " " + usuarioActualizacion.segundoApellido,
                      obra,
                      usuarioActualizacion
                    } as ObrasHistoricoDto;
                  })
                )),
                toArray()
              )
            ),
            take(1)
          ).toPromise();
          this.obrasHistoricoCompleto = this.obrasHistorico;
          let obraSeleccionada = {
            nombreEstado: this.obraSeleccionada.nombreEstado,
            nombreObra: this.obraSeleccionada.nombreObra,
            nombreTipoCarpeta: '',
            nombreTipoSeccion: '',
            fechaActualizacion: new Date(this.obraSeleccionada.obra.fechaActualizacion),
            nombreUsuarioActualizacion: 'Registro Actual',
            nombreTipoRecurso: this.catTiposOrigenRecursos.find((origenRecurso: ElementoCatalogo) => origenRecurso.key === this.obraSeleccionada.obra.keyCatOrigenRecursos).nombre,
            obra: this.obraSeleccionada.obra,
            usuarioActualizacion: {}
          };
          this.obrasHistoricoCompleto.unshift(obraSeleccionada);
          this.obraSeleccionadaBool = true;
        }
      }
    );
  }

  public reiniciarFiltros(event, dt) {
    this.nombreOrgienRecursos['_results'].forEach(ds => {
      ds.value = null;
      ds.updateLabel();
    });
    dt.filter('', 'obra.keyCatOrigenRecursos', 'contains');

    this.table.reset();
  }

  public enviarInformacionObra(datosObraHistorico) {
    this.obraHistoricoService.establecerDatosObraHistorico(datosObraHistorico);
    this.modalFichaTecnicaHistorico.abrirModal();
  }

}
